module.exports = __webpack_public_path__ + "img/4.d273a3fa.jpg";